import { Directive, HostListener, Optional } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: '[appLimitarAno]'
})
export class LimitarAnoDirective {
  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const valor = event.target.value;
    if (!valor) return;

    const partes = valor.split('-');
    if (partes[0] && partes[0].length > 4) {
      partes[0] = partes[0].slice(0, 4);
      const corrigindo = partes.join('-');
      event.target.value = corrigindo;
      this.ngControl?.control?.setValue(corrigindo);
    }
  }
}
